var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',[_c('polygon',{attrs:{"points":"18.43 7.72 19.5 8.78 12 16.28 4.5 8.78 5.57 7.72 12 14.16 18.43 7.72"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }